var _module_exports = "    <select ng-model=\"mode\"\r\n            ng-options=\"cm.value as cm.name for cm in campaignMode\">\r\n    </select>\r\n";;
var path = '/app/components/campaigns/directives/campaignModeSelectorTemplate.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;